module.exports = new __parcel__URL__("PublicLinkPermissionsSpotlight.328990b4.svg").toString();